import { ofType } from 'redux-observable';
import { concat, of } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';

import { SLIDES_ENDPOINT_URL } from '../../../common/constants/request';

import logger from '../../../common/helpers/logger';
import { tmPostRequest } from '../../../common/helpers/request';
import { errorTranscriptAction, getSlidesAction, setLoadingStateAction, setSlidesAction } from '../slices/slides';

export default (action$) =>
  action$.pipe(
    ofType(getSlidesAction.type),
    mergeMap(({ payload }) => {
      const stream$ = tmPostRequest({
        url: SLIDES_ENDPOINT_URL,
        body: {
          videoId: payload.videoId,
        },
      }).pipe(
        switchMap(({ response }) =>
          concat(
            of(setLoadingStateAction(false)),
            of(
              setSlidesAction({
                pdfFile: response?.pdfFile || '',
                slides: response?.slides ?? [],
                download: response?.download ?? false,
              }),
            ),
          ),
        ),
        catchError((error) => {
          logger.error('modules/PlayerOverview/redux/epics/getSlides', error);

          return concat(of(setLoadingStateAction(false)), of(errorTranscriptAction()));
        }),
      );

      return concat(of(setLoadingStateAction(true)), stream$);
    }),
  );
